// @ts-nocheck
/*
 * Port of service/releaseCenterService.js (53L). BYTE-IDENTICAL.
 * All release-center REST calls proxied through httpCall.
 */
import { getApiCall, postApiCall } from '@/service/httpCall';
import {
  API_RELEASE_CENTER_LIST,
  API_RELEASE_CENTER_STATS,
  API_RELEASE_CENTER_TAGS,
  API_RELEASE_CENTER_COMPARE,
  API_RELEASE_CENTER_SINGLE,
  API_RELEASE_CENTER_CREATE,
  API_RELEASE_CENTER_UPDATE,
  API_RELEASE_CENTER_PUBLISH,
  API_RELEASE_CENTER_PIN,
  API_RELEASE_CENTER_DISABLE,
} from '@/service/url';

const toQuery = (params: any = {}) => {
  const entries = Object.entries(params).filter(
    ([, v]: any) => v !== undefined && v !== null && v !== '',
  );
  if (!entries.length) return '';
  const qs = entries
    .map(
      ([k, v]: any) =>
        `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
    )
    .join('&');
  return `?${qs}`;
};

export const listReleases = (params: any = {}) =>
  getApiCall(`${API_RELEASE_CENTER_LIST}${toQuery(params)}`);

export const getReleaseStats = () => getApiCall(API_RELEASE_CENTER_STATS);

export const getReleaseTags = () => getApiCall(API_RELEASE_CENTER_TAGS);

export const getRelease = (id: any) =>
  getApiCall(API_RELEASE_CENTER_SINGLE.replace(':id', id));

export const compareReleases = (a: any, b: any) =>
  getApiCall(`${API_RELEASE_CENTER_COMPARE}${toQuery({ a, b })}`);

export const createRelease = (payload: any) =>
  postApiCall(API_RELEASE_CENTER_CREATE, payload);

export const updateRelease = (id: any, payload: any) =>
  postApiCall(API_RELEASE_CENTER_UPDATE.replace(':id', id), payload);

export const setReleasePublished = (id: any, is_published: boolean) =>
  postApiCall(API_RELEASE_CENTER_PUBLISH.replace(':id', id), { is_published });

export const setReleasePinned = (id: any, is_pinned: boolean) =>
  postApiCall(API_RELEASE_CENTER_PIN.replace(':id', id), { is_pinned });

export const setReleaseDisabled = (id: any, is_disabled: boolean) =>
  postApiCall(API_RELEASE_CENTER_DISABLE.replace(':id', id), { is_disabled });
